import { Platform } from 'react-native';

/**
 * Determines whether it's safe to use @gorhom/bottom-sheet in the current runtime.
 * Expo Go and environments without Reanimated worklet init should return false.
 */
export function canUseGorhomBottomSheet(): boolean {
  if (Platform.OS === 'web') return false;

  // Require Reanimated worklets to be initialized
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const hasWorklets = typeof (globalThis as any).__reanimatedWorkletInit === 'function';
  if (!hasWorklets) return false;

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Constants = require('expo-constants');
    if (Constants?.appOwnership === 'expo' || Constants?.executionEnvironment === 'storeClient') {
      return false;
    }
  } catch {
    // ignore and allow fallthrough
  }

  return true;
}

